module.exports = __webpack_public_path__ + "static/img/login_header.4741573.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login2/login_header.png
// module id = /i2p
// module chunks = 0